import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import get from 'lodash/get';
import flatten from 'lodash/flatten';
import { MATERIAL } from '../../Constants/Steps';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';

const useStyles = makeStyles((theme) => ({
  noticeContainer: {
    [theme.breakpoints.up('xs')]: {
      padding: '0px 20px',
    },
    [theme.breakpoints.down('xs')]: {
      padding: 0,
    },
  },
  noticeText: {
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.7rem',
    },
  },
}));

export const Notice = () => {
  const { selectedStage, selectedoptionclassification, displayVisualizationNote } = useSelector(
    (state) => state.configurator
  );
  const classes = useStyles();

  if (selectedStage !== MATERIAL) {
    return null;
  }

  const selectedOptions = get(selectedoptionclassification, 'selectedoptions', []);
  const filteredAttributes = selectedOptions
    .map(({ attributes }) =>
      attributes.find((attr) => {
        if (attr.identifier === 'fabric_notice') {
          return attr.values;
        }
      })
    )
    .filter((val) => val);

  const attrValues =
    filteredAttributes.length > 0 ? flatten(filteredAttributes.map((a) => a && a.values)) : [];

  return (
    <div className={classes.noticeContainer}>
      <Typography className={classes.noticeText} variant="body2">
        {t('visualizationHint')}
      </Typography>
      {displayVisualizationNote && (
        <Typography className={classes.noticeText} variant="body2">
          {t('visualizationNote')}
        </Typography>
      )}
      {attrValues.length > 0 &&
        attrValues.map((value, i) => (
          <Typography className={classes.noticeText} key={i} variant="body2">
            {get(value, 'translated_value', '')}
          </Typography>
        ))}
    </div>
  );
};

export default Notice;
